var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMonCompte = function SvgIconMonCompte(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-mon-compte",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-388.329 -183.281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tune"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M404.079 187.531h-9.113v-2.5h9.113a1.25 1.25 0 0 1 1.25 1.25 1.25 1.25 0 0 1-1.25 1.25Z",
    fill: "#1eaae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M390.579 185.031h4.387v2.5h-4.387a1.25 1.25 0 0 1-1.25-1.25 1.25 1.25 0 0 1 1.25-1.25Z",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 3,
    height: 6,
    rx: 1.5,
    transform: "translate(392.329 183.281)",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tune-2",
    "data-name": "tune"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M404.079 192.531h-4.113v-2.5h4.113a1.25 1.25 0 0 1 1.25 1.25 1.25 1.25 0 0 1-1.25 1.25Z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M390.579 190.031h9.387v2.5h-9.387a1.25 1.25 0 0 1-1.25-1.25 1.25 1.25 0 0 1 1.25-1.25Z",
    fill: "#ff8500"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 3,
    height: 6,
    rx: 1.5,
    transform: "translate(398.329 188.281)",
    fill: "#505050"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tune-3",
    "data-name": "tune"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M404.079 197.531h-9.113v-2.5h9.113a1.25 1.25 0 0 1 1.25 1.25 1.25 1.25 0 0 1-1.25 1.25Z",
    fill: "#8ccd32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M390.579 195.031h4.387v2.5h-4.387a1.25 1.25 0 0 1-1.25-1.25 1.25 1.25 0 0 1 1.25-1.25Z",
    fill: "#467846"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 3,
    height: 6,
    rx: 1.5,
    transform: "translate(394.329 193.281)",
    fill: "#505050"
  })))));
};
export { SvgIconMonCompte as ReactComponent };
export default "data:image/svg+xml;base64,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";